export default "__VITE_ASSET__34SR02_d__"